import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Check, MessageCircle, Plus } from 'lucide-react';
import '../../services.css';

const WHATSAPP_NUMBER = '971561868236';

export const whatsappHref = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const ServiceHero = ({ eyebrow, title, intro, image, imageAlt, ctaLabel, ctaMessage, secondaryLabel, secondaryTo }) => (
  <section className="service-hero">
    <div className="service-hero-copy">
      <p className="service-eyebrow"><span />{eyebrow}</p>
      <h1>{title}</h1>
      <p className="service-lead">{intro}</p>
      <div className="service-hero-actions">
        <a className="service-button service-button-primary" href={whatsappHref(ctaMessage)} target="_blank" rel="noopener noreferrer">
          <MessageCircle size={18} />{ctaLabel}<ArrowUpRight size={16} />
        </a>
        {secondaryLabel && secondaryTo && (
          <Link className="service-button service-button-ghost" to={secondaryTo}>{secondaryLabel}</Link>
        )}
      </div>
    </div>
    <div className="service-hero-media">
      <img src={image} alt={imageAlt} loading="eager" />
    </div>
  </section>
);

export const ServiceChecklist = ({ title, points, eyebrow }) => (
  <section className="service-section service-checklist">
    <div className="service-section-head">
      {eyebrow && <p className="service-eyebrow"><span />{eyebrow}</p>}
      <h2>{title}</h2>
    </div>
    <ul className="service-checklist-grid">
      {points.map((point) => (
        <li key={point}>
          <span className="service-check-icon"><Check size={15} /></span>
          <span>{point}</span>
        </li>
      ))}
    </ul>
  </section>
);

export const ServiceFaq = ({ title, items }) => (
  <section className="service-section service-faq">
    <h2>{title}</h2>
    <div className="service-faq-list">
      {items.map(({ q, a }) => (
        <details className="service-faq-item" key={q}>
          <summary>
            {q}
            <Plus size={17} className="service-faq-toggle" />
          </summary>
          <p>{a}</p>
        </details>
      ))}
    </div>
  </section>
);

export const RelatedServices = ({ title, items, lang }) => (
  <section className="service-section service-related">
    <h2>{title}</h2>
    <div className="service-related-grid">
      {items.map(({ title: itemTitle, description, route }) => (
        <Link className="service-related-card" to={`/${lang}/services/${route}`} key={route}>
          <span>{itemTitle}</span>
          <p>{description}</p>
          <ArrowUpRight size={16} />
        </Link>
      ))}
    </div>
  </section>
);

export const ServiceCta = ({ eyebrow, title, body, ctaLabel, ctaMessage }) => (
  <section className="service-cta">
    <div className="service-cta-inner">
      <p className="service-eyebrow"><span />{eyebrow}</p>
      <h2>{title}</h2>
      <p>{body}</p>
      <div className="service-hero-actions">
        <a className="service-button service-button-primary" href={whatsappHref(ctaMessage)} target="_blank" rel="noopener noreferrer">
          <MessageCircle size={18} />{ctaLabel}<ArrowUpRight size={16} />
        </a>
        <a className="service-button service-button-ghost" href="tel:+971561868236">
          <bdi dir="ltr" className="service-phone">+971 56 186 8236</bdi>
        </a>
      </div>
    </div>
  </section>
);

const ServicePage = ({ isRTL, className = '', children }) => (
  <div className={`service-page ${className}`} dir={isRTL ? 'rtl' : 'ltr'}>
    {children}
  </div>
);

export default ServicePage;
